import { Component, ElementRef, HostBinding, ViewChild } from '@angular/core';
import { AlertPopup, config, HttpLoader } from 'app/app.config';
import { debounceTime, Subject } from 'rxjs';
import { CompaniesService } from './companies.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { AppComponent } from 'app/app.component';
import { ConfirmationDialogService } from 'app/confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-companies',
  // imports: [],
  templateUrl: './companies.component.html',
  styleUrl: './companies.component.scss',
  standalone: false
})
export class CompaniesComponent {

  @HostBinding('class.flex-grid') leftBarClass = true;
  @HostBinding('style.width') flexwidth = '100%';
  @ViewChild('fileInput') fileInput: ElementRef;


  listOfClients: any[] = [];
  totalRowCount: number = 0;
  RECORD_LIMIT: number = config.DEFAULT_RECORD_LIMIT;
  OFFSET: number = config.DEFAULT_OFFSET;
  sortBy = 'name';
  currentPage: number = 0;
  page: number = 1;

  search: string = '';
  showBtnSpinner: boolean = false;
  showPaginateLoader: boolean = false;
  searchInList = new Subject<any>();

  constructor(
    private companyService: CompaniesService,
    private router: Router,
    private route: ActivatedRoute,
    private httpLoader: HttpLoader,
    private alert: AlertPopup,
    private fb: FormBuilder,
    private app: AppComponent,
    private confirmDialogService: ConfirmationDialogService
  ) {
    this.searchInList.pipe(
      debounceTime(500)
    )
      .subscribe(event => {
        this.search = event.target.value;
        this.getClientListSortAndSearch(0)
      })
  }

  ngOnInit(): void {
    this.getClientListSortAndSearch(0);
  }

  getClientListSortAndSearch(pageNo: number): void {
    try {
      if (pageNo === 0) {
        this.httpLoader.showLoader();
      }

      this.OFFSET = pageNo;

      const payload = {
        offset: this.OFFSET,
        limit: 10000,
        sort: this.sortBy,
        search: this.search?.trim() || ''
      }

      this.companyService.getClient(payload).subscribe({
        next: (response: any) => {
          this.httpLoader.hideLoader();

          const clients = response.data || [];

          this.listOfClients = clients;

          this.totalRowCount = response.totalRowCount;
        }
      })

    } catch (error:any) {
      this.httpLoader.hideLoader();
      this.alert.showAlertMessage(error?.error || 'Something went wrong');
    }

  }

  get showingCount(): number {
    return Math.min(this.page * this.RECORD_LIMIT, this.totalRowCount);
  }


  changeClientStatus(item: any, status: any) {

  }


  createNew(){
    this.router.navigate(['/company/create-edit'])
  }


  editClient(item: any) {
    this.router.navigate(['/company/create-edit'], {
      queryParams: {
        id: item.id
      }
    })
  }


  deleteClient(item: any) {

  }


}
